export function isBlob(value: unknown): value is Blob {
  if (typeof value !== 'object' || value === null) return false
  const candidate = value as Partial<Blob>
  return (
    typeof candidate.size === 'number' &&
    Number.isFinite(candidate.size) &&
    candidate.size >= 0 &&
    typeof candidate.type === 'string' &&
    typeof candidate.slice === 'function'
  )
}
